module.exports = function() {

	$(document).ready(function () {

		if(!getCookie("cookie-close")){
			$('.cookie-notification').fadeIn();
		}

		$('#cookie-close').on( 'click', function() {

			var expires = "";
			var value = true;
			var date = new Date();
			date.setTime(date.getTime() + (7*24*60*60*1000));
			expires = "; expires=" + date.toUTCString();
			document.cookie = 'cookie-close' + "=" + (value || "")  + expires + "; path=/";

			$('.cookie-notification').fadeOut();
		});

		function getCookie(name) {

			var dc = document.cookie;
			var prefix = name + "=";
			var begin = dc.indexOf("; " + prefix);
			if (begin == -1) {
				begin = dc.indexOf(prefix);
				if (begin != 0) return null;
			}
			else
			{
				begin += 2;
				var end = document.cookie.indexOf(";", begin);
				if (end == -1) {
					end = dc.length;
				}
			}
			return decodeURI(dc.substring(begin + prefix.length, end));
		}
	});
}();